import OptimizedImage from "@components/ui/OptimizedImage"
import { useRoutePageContext } from "@components/ui/route-page-context"
import * as m from "@paraglide/messages"
export function Title() {
  const { locale } = useRoutePageContext()

  return (
    <a
      className="block h-[calc(156px+1rem)] w-[var(--side-menu-width)]"
      href={`/${locale}`}
      aria-label="Menu Logo"
    >
      <OptimizedImage
        src="/playbrain-word-logo-white.svg"
        alt={(m.common_playbrain({}, { locale: locale }) ?? "PLAYBRAIN").toUpperCase()}
        width={208}
        height={40}
        className="relative top-[-50px] mt-[50px] ml-[50px] h-[var(--side-menu-width)] w-auto origin-top-left p-[10px] [rotate:90deg]"
      />
    </a>
  )
}

export default Title
